import { Dropdown } from 'semantic-ui-react';

import { PROFILE_LABEL, SIGN_OUT_LABEL } from '../MainHeader.constants';

interface UserMenuProps {
  username: string;
  handleProfileClick: () => void;
  handleLogoutClick: () => void;
}

const UserMenu = ({
  username,
  handleProfileClick,
  handleLogoutClick,
}: UserMenuProps) => {
  return (
    <Dropdown className='user-menu-item' item icon='user' text={username}>
      <Dropdown.Menu>
        <Dropdown.Item onClick={handleProfileClick}>
          {PROFILE_LABEL}
        </Dropdown.Item>
        <Dropdown.Item onClick={handleLogoutClick}>
          {SIGN_OUT_LABEL}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserMenu;
